class SiteBreakpoints {
  get width() {
    return window.innerWidth;
  }

  get height() {
    return window.innerHeight;
  }

  get smallTabletOrDown() {
    return this.width <= 768;
  }
}

export default new SiteBreakpoints();
